"use strict";
"use es6";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _reactDom = require("react-dom");

var _UIFileInput = require("UIComponents/input/UIFileInput");

var _UIFileInput2 = _interopRequireDefault(_UIFileInput);

var _UIDropZone = require("UIComponents/drop/UIDropZone");

var _UIDropZone2 = _interopRequireDefault(_UIDropZone);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var DropzoneUploader = function (_Component) {
  _inherits(DropzoneUploader, _Component);

  function DropzoneUploader(props) {
    _classCallCheck(this, DropzoneUploader);

    var _this = _possibleConstructorReturn(this, (DropzoneUploader.__proto__ || Object.getPrototypeOf(DropzoneUploader)).call(this, props));

    _this.state = {
      dropzoneUse: "default",
      file: props.defaultFile || null,
      error: null
    };

    _this.stopEvent = _this.stopEvent.bind(_this);
    _this.handleDrop = _this.handleDrop.bind(_this);
    _this.handleDropZoneClick = _this.handleDropZoneClick.bind(_this);
    _this.handleDragOver = _this.handleDragOver.bind(_this);
    _this.handleDragExit = _this.handleDragExit.bind(_this);
    _this.handleFileChange = _this.handleFileChange.bind(_this);
    return _this;
  }

  _createClass(DropzoneUploader, [{
    key: "handleDropZoneClick",
    value: function handleDropZoneClick(evt) {
      var inputNode = (0, _reactDom.findDOMNode)(this.fileInput);
      if (!inputNode.contains(evt.target)) {
        this.fileInput.handleClick();
      }
    }
  }, {
    key: "handleFileChange",
    value: function handleFileChange(evt) {
      if (evt.target.value === undefined) {
        return;
      }
      this.readFile(evt.target.value);
    }
  }, {
    key: "handleDrop",
    value: function handleDrop(evt) {
      this.stopEvent(evt);
      if (evt.dataTransfer.files.length !== 1) {
        this.onError('Only a single image may be uploaded.');
        return;
      }
      this.readFile(evt.dataTransfer.files[0]);
    }
  }, {
    key: "handleDragOver",
    value: function handleDragOver(evt) {
      this.stopEvent(evt);
      this.setState({ dropzoneUse: "hover" });
    }
  }, {
    key: "handleDragExit",
    value: function handleDragExit(evt) {
      this.stopEvent(evt);
      this.setState({ dropzoneUse: "default" });
    }
  }, {
    key: "readFile",
    value: function readFile(file) {
      var _this2 = this;

      var onChange = this.props.onChange;


      if (file.type.indexOf("image/") !== 0) {
        this.onError('Only an image file may be uploaded.');
        return;
      }
      var reader = new FileReader();
      this.setState({ fileUploading: true });
      reader.onload = function () {
        _this2.setState({
          file: file,
          fileUploading: false,
          dropzoneUse: "success",
          error: null
        });
        onChange(reader.result);
      };
      reader.readAsDataURL(file);
    }
  }, {
    key: "stopEvent",
    value: function stopEvent(evt) {
      evt.preventDefault();
      evt.stopPropagation();
    }
  }, {
    key: "onError",
    value: function onError(errorText) {
      var onChange = this.props.onChange;


      this.setState({
        error: errorText,
        dropzoneUse: "error",
        file: null
      });
      onChange(null);
    }
  }, {
    key: "renderFileInput",
    value: function renderFileInput() {
      var _this3 = this;

      var _state = this.state,
          file = _state.file,
          fileUploading = _state.fileUploading;

      var ref = function ref(c) {
        _this3.fileInput = c;
      };
      return _react2.default.createElement(_UIFileInput2.default, {
        ref: ref,
        accept: ["image/*"],
        onChange: this.handleFileChange,
        use: "tertiary-light",
        value: file,
        disabled: fileUploading
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this4 = this;

      var _state2 = this.state,
          file = _state2.file,
          dropzoneUse = _state2.dropzoneUse,
          error = _state2.error;

      var ref = function ref(c) {
        _this4.dropzone = c;
      };
      if (error || file === null) {
        return _react2.default.createElement(
          _UIDropZone2.default,
          {
            iconName: "photo",
            size: "large",
            ref: ref,
            use: dropzoneUse,
            onDrag: this.stopEvent,
            onDragStart: this.stopEvent,
            onDragEnd: this.handleDragExit,
            onDragOver: this.handleDragOver,
            onDragEnter: this.handleDragOver,
            onDragLeave: this.handleDragExit,
            onDrop: this.handleDrop,
            onClick: this.handleDropZoneClick
          },
          error ? _react2.default.createElement(
            "div",
            null,
            error
          ) : null,
          _react2.default.createElement(
            "div",
            null,
            this.renderFileInput()
          )
        );
      }
      return this.renderFileInput();
    }
  }]);

  return DropzoneUploader;
}(_react.Component);

DropzoneUploader.propTypes = {
  onChange: _react.PropTypes.func.isRequired,
  defaultFile: _react.PropTypes.instanceOf(File)
};

exports.default = DropzoneUploader;
module.exports = exports["default"];


//////////////////
// WEBPACK FOOTER
// ./js/components/avatar/DropzoneUploader.js
// module id = 333
// module chunks = 0